import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { LanguagesMessages, operateTypeMessages } from "@saleor/misc";
import { FilterOpts } from "@saleor/types";
import {
  LanguageCodeFilter,
  PageUserEventsEnum,
  UserOperatePageEventOperateType
} from "@saleor/types/globalTypes";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { IntlShape } from "react-intl";
export enum PageEventFilterKeys {
  operateType = "operateType",
  languageCode = "languageCode"
}
export interface PageEventListFilterOpts {
  operateType: FilterOpts<PageUserEventsEnum[]>;
  languageCode: FilterOpts<LanguageCodeFilter[]>;
}
export function createFilterStructure(
  intl: IntlShape,
  opts: PageEventListFilterOpts
): IFilter<PageEventFilterKeys> {
  return [
    {
      ...createOptionsField(
        PageEventFilterKeys.operateType,
        intl.formatMessage(operateTypeMessages.type),
        opts.operateType.value,
        true,
        [
          {
            label: intl.formatMessage(operateTypeMessages.add),
            value: UserOperatePageEventOperateType.CREATE_PAGE
          },
          {
            label: intl.formatMessage(operateTypeMessages.update),
            value: UserOperatePageEventOperateType.UPDATE_PAGE
          },
          {
            label: intl.formatMessage(operateTypeMessages.release),
            value: UserOperatePageEventOperateType.RELEASE_PAGE
          },
          {
            label: intl.formatMessage(operateTypeMessages.remove),
            value: UserOperatePageEventOperateType.REMOVE_PAGE
          }
        ]
      ),
      active: opts.operateType.active
    },
    {
      ...createOptionsField(
        PageEventFilterKeys.languageCode,
        intl.formatMessage(commonMessages.languages),
        opts.languageCode.value,
        true,
        [
          {
            label: intl.formatMessage(LanguagesMessages.en),
            value: LanguageCodeFilter.EN
          },
          {
            label: intl.formatMessage(LanguagesMessages.ar),
            value: LanguageCodeFilter.AR
          },
          {
            label: intl.formatMessage(LanguagesMessages.pt),
            value: LanguageCodeFilter.PT
          },
          {
            label: intl.formatMessage(LanguagesMessages.de),
            value: LanguageCodeFilter.DE
          },
          {
            label: intl.formatMessage(LanguagesMessages.es),
            value: LanguageCodeFilter.ES
          },
          {
            label: intl.formatMessage(LanguagesMessages.fr),
            value: LanguageCodeFilter.FR
          },
          {
            label: intl.formatMessage(LanguagesMessages.ja),
            value: LanguageCodeFilter.JA
          },
          {
            label: intl.formatMessage(LanguagesMessages.zh_hans),
            value: LanguageCodeFilter.ZH_HANS
          },
          {
            label: intl.formatMessage(LanguagesMessages.zh_hant),
            value: LanguageCodeFilter.ZH_HANT
          }
        ]
      ),
      active: opts.languageCode.active
    }
  ];
}
